import { useAppSelector } from "../app/hooks";
import * as authSlice from "../features/auth/auth.slice";
import AdminDashboard from "../features/dashboard/admin-dashboard";
import MemberDashboard from "../features/dashboard/member-dashboard";
import UserDashboard from "../features/dashboard/user-dashboard";
import { UserType } from "../shared/enums";

const Dashboard = () => {
    const loggedInUser = useAppSelector(authSlice.selectLoggedInUser);

    return (
        <div>
            {loggedInUser?.type === UserType.GYMINIFY &&
                <AdminDashboard />
            }
            {loggedInUser?.type === UserType.BUSINESS_USER &&
                <UserDashboard />
            }
            {loggedInUser?.type === UserType.MEMBER &&
                <MemberDashboard />
            }
        </div>
    )
}

export default Dashboard;